<header class="header" [class.sticky]="isSticky()">
  <navigation-topbar [userCanStartSelfservice]="userCanStartSelfservice()" />
  @if (router.url !== "/error") {
    <div class="navigation" [class.fixed]="false">
      <div class="container">
        <div class="navigation__flex" [class.terminated]="terminated()">
          <div class="navigation__text--wrapper">
            @if (localProductType()) {
              <service-icon
                size="l"
                [type]="iconType()"
                [active]="!terminated()"
                [firewallEnabled]="firewallOverlapVisible()"
              />
            }
            @if (IPPrefixIconVisible()) {
              <service-icon size="l" type="ip_prefix" />
            }
            @if (certIconVisible()) {
              <service-icon size="l" type="cert" />
            }
            @if (domainsIconVisible()) {
              <service-icon size="l" type="domains" />
            }
            @if (iotnetIconVisible()) {
              <service-icon size="l" type="iotnet" />
            }
            <span class="navigation__text">
              @if (backEnabled() && localIsChildRoute()) {
                <button (click)="goBack()" class="navigation__text--top navigation__back">
                  <svg-icon src="assets/images/icons/icon-arrow-left.svg" class="back-button"> </svg-icon>
                  {{ "Global.Action.Back" | translate }}
                </button>
              } @else if (routeTitle()) {
                <span class="navigation__text--top">{{ routeTitle() }}</span>
              }

              @if (!isDetailPage()) {
                <span class="navigation__text--main"> {{ forceTitle() ? forceTitle() : mainNavText() }}</span>
              }

              @if (isDetailPage() && detailData() !== undefined) {
                <span class="navigation__text--main">
                  @if (!isWireless() && !terminated()) {
                    <svg-icon
                      src="assets/images/icons/status-{{ detailData()!.status | status_to_icon }}.svg"
                      class="table__status status-icon"
                    ></svg-icon>
                  }
                  @if (terminated()) {
                    <svg-icon
                      src="assets/images/icons/status-terminated.svg"
                      class="table__status status-icon"
                    ></svg-icon>
                  }
                  <span class="navigation__truncate">{{ detailData()!.title }}</span>
                </span>
              }
            </span>
          </div>
          <div class="navigation__right">
            <!-- this will contain the components for self-service and the overview button -->
            @if (userCanStartSelfservice()) {
              <selfservice-status />
            }
            <span class="navigation__divider"></span>
          </div>
        </div>
      </div>
      @if (subNavItems().length > 0) {
        <div class="navigation__sub">
          <div class="container">
            <div class="navigation__sub-flex">
              @for (item of subNavItems(); track $index) {
                <a href="" [routerLink]="item.link" routerLinkActive="active">
                  {{ item.title | translate }}
                </a>
              }
            </div>
          </div>
        </div>
      }
    </div>
  }
</header>

<grote-storing-banner />
@if (showMaintenanceBanner() || auth.configuration().userInterviewEnabled) {
  <div class="banners-container">
    @if (showMaintenanceBanner()) {
      <maintenance-banner [maintenanceBanner]="maintenanceBanner()" />
    }
    @if (auth.configuration().userInterviewEnabled) {
      <user-interview-banner></user-interview-banner>
    }
  </div>
}
